import {gql} from 'graphql-request';
import {useMutation} from '@tanstack/react-query';
import userStateGraphQLClient from '../services/UserStateApi/graphqlClient';

const useSetRegistryGoal = () =>
  useMutation(async ({goalId, customGoal: goalCustomInput}) =>
    userStateGraphQLClient.request(
      gql`
        mutation SetGoal($goalId: Int!, $goalCustomInput: String) {
          setGoal(goalId: $goalId, goalCustomInput: $goalCustomInput) {
            success
            message
            user {
              memberId
              goal {
                goalId
                goalCustomInput
              }
            }
          }
        }
      `,
      {
        goalId,
        goalCustomInput,
      },
    ),
  );

export default useSetRegistryGoal;
